module.exports = "/assets/data/8abe71b0c065ae4934f8ae8e2d2f5959-CF14.data.json";